import React from 'react';
import classnames from 'classnames';
import { colors } from '@nerdwallet/base-styles/variables';
import styles from "./match-score-ring.module.css";
var MatchScoreRing = function MatchScoreRing(_ref) {
  var isKetoCard = _ref.isKetoCard,
    matchScore = _ref.matchScore,
    matchScoreColor = _ref.matchScoreColor,
    matchScoreRingColor = _ref.matchScoreRingColor;
  /*
  How this match score circle chart is drawn for the marketplace product card:
  1. Draw a solid circle (green or yellow)
  2. Draw a semi-transparent white sector. The sector will be smaller the higher the match score is.
  3. Draw a smaller solid white circle in the center
  */
  var radius = 21;
  var diameter = radius * 2;

  // center coordinates of the circle
  var centerX = 21;
  var centerY = 21;

  // percentage of the ring to be filled
  var percentage = matchScore / 100;

  // calculate starting angle for the sector. Subtract 90 degrees because theta is the angle from the x-axis (the 90 degree mark)
  var theta = (percentage * 360 - 90) * Math.PI / 180;
  var startX = centerX + radius * Math.cos(theta);
  var startY = centerY + radius * Math.sin(theta);

  // whether the sector is larger than 180 degrees
  var isLargeArc = percentage < 0.5 ? 1 : 0;
  var sectorPath = "M ".concat(startX, " ").concat(startY, "\n    A ").concat(radius, " ").concat(radius, " 0 ").concat(isLargeArc, " 1 ").concat(radius, " 0\n    L ").concat(centerX, " ").concat(centerY);
  var innerCircleRadius = '11';

  // -3 because `stroke-linecap: round` adds extra length that we don't want to the ring; and design decision to make >=90 100%
  var ringPercentage = matchScore >= 90 ? 100 : matchScore - 3;
  return isKetoCard ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 45 45",
    width: 32,
    height: 32,
    className: classnames(styles.circularChart),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    className: styles.circleBg,
    d: "M22 6 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831",
    stroke: colors[matchScoreRingColor]
  }), /*#__PURE__*/React.createElement("path", {
    className: styles.circle,
    strokeDasharray: "".concat(ringPercentage, " 100"),
    d: "M22 6 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831",
    stroke: colors[matchScoreColor]
  })) : /*#__PURE__*/React.createElement("svg", {
    width: diameter,
    height: diameter,
    viewBox: "0 0 ".concat(diameter, " ").concat(diameter),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: centerX,
    cy: centerY,
    r: radius,
    fill: colors[matchScoreColor]
  }), /*#__PURE__*/React.createElement("path", {
    d: sectorPath,
    fill: "white",
    fillOpacity: "0.75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: centerX,
    cy: centerY,
    r: innerCircleRadius,
    fill: "white"
  }));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  MatchScoreRing.propTypes = {
    isKetoCard: PropTypes.bool,
    matchScore: PropTypes.number.isRequired,
    matchScoreColor: PropTypes.oneOf(['green', 'yellow']),
    matchScoreRingColor: PropTypes.oneOf(['green-lightest', 'yellow-lightest'])
  };
}
MatchScoreRing.defaultProps = {
  isKetoCard: false
};
export default MatchScoreRing;